<template>
  <div class="phone">
    <span class="phone__name">{{ label }}</span>
    <div
      class="phone__body"
      :class="{
        'phone__body--valid': valid,
        'phone__body--invalid': valid === false,
        'phone__body--removable': removable
      }"
    >
      <TheMask
        mask="+###"
        v-model="countryCode"
        placeholder="+___"
        class="input"
        :masked="true"
        @input="emitValue"
      />
      <TheMask
        mask="(###) ###-##-##"
        v-model="phone"
        placeholder="(___) ____-__-__"
        :masked="true"
        @input="emitValue"
      />
      <button v-if="removable" class="phone__remove" @click="removeIt">
        <svg-icon type="trashcan" />
      </button>
    </div>
  </div>
</template>

<script>
import { mask, TheMask } from "vue-the-mask";
export default {
  name: "CPhone",
  props: ["label", "defaultValue", "removable"],
  directives: { mask },
  components: { TheMask },
  data() {
    return {
      countryCode: "",
      phone: "",
      valid: this.defaultValue ? !!this.defaultValue : null
    };
  },
  mounted() {
    // Попытка распарсить номер телефона
    let splitted = this.defaultValue.split(" ");
    if (splitted.length > 1) {
      if (splitted[0].length <= 4) {
        this.countryCode = splitted.shift();
        this.phone = splitted.join("");
      }
    } else {
      if (this.defaultValue.length <= 10) {
        this.phone = this.defaultValue;
      } else {
        this.countryCode = this.defaultValue.substring(
          0,
          this.defaultValue.length - 10
        );
        this.phone = this.defaultValue.substring(this.defaultValue.length - 10);
      }
    }
    if (this.valid) {
      this.$emit("valid");
    } else {
      this.$emit("invalid");
    }
  },
  methods: {
    emitValue() {
      this.$emit("input", `${this.countryCode} ${this.phone}`);
      if (`${this.countryCode} ${this.phone}`.length > 4) {
        this.$emit("valid");
      } else {
        this.$emit("invalid");
      }
    },
    removeIt() {
      this.$emit("removeit");
    }
  }
};
</script>

<style lang="scss" scoped>
.phone {
  margin-bottom: 20px;
  &__name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    display: inline-block;
  }
  &__body {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    max-width: 100%;
    input {
      border: 1px solid #cccccc;
      outline: none;
      border-radius: 5px;
      padding: 10px 15px;
      font-size: 16px;
      background: transparent;
      resize: none;
      font-family: "Inter", sans-serif;
      &:first-child {
        flex-basis: calc(28% - 5px);
        max-width: calc(28% - 5px);
      }
      &:nth-child(2) {
        flex-basis: calc(72% - 5px);
        max-width: calc(72% - 5px);
      }
      &:focus {
        border-color: #3479cc;
      }
    }
    &--valid input {
      border-color: #3479cc;
    }
    &--invalid input {
      border-color: #ff0000;
    }
    &--removable input {
      &:first-child {
        flex-basis: calc(28% - 23px);
        max-width: calc(28% - 23px);
        margin-right: 10px;
      }
      &:nth-child(2) {
        flex-basis: calc(72% - 25px);
        max-width: calc(72% - 25px);
      }
    }
  }
  &__remove {
    display: flex;
    padding: 10px;
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }
}
</style>
